import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'

export interface PlatformKeyBannerProps {
    visible: boolean
    showCTA: boolean
    onCTAClick?: () => void
}

function PlatformKeyBanner({ visible, showCTA, onCTAClick }: PlatformKeyBannerProps) {
    const { t } = useTranslation('common')

    if (!visible) return null

    return (
        <Alert
            severity="warning"
            action={
                showCTA ? (
                    <Button
                        variant="outlined"
                        size="small"
                        color="warning"
                        onClick={onCTAClick}
                        aria-label={t('platformKeyBanner.ctaAriaLabel')}
                        sx={{ whiteSpace: 'nowrap' }}
                    >
                        {t('platformKeyBanner.ctaLabel')}
                    </Button>
                ) : undefined
            }
            sx={{
                width: '100%',
                borderRadius: 0,
            }}
        >
            {t('platformKeyBanner.message')}
        </Alert>
    )
}

export default PlatformKeyBanner
